import axios from "../axios-auth";

export const shiftInfoService = {
    getShiftInfoList,
    getShiftInfosByShopId,
    saveShiftInfo,
    getShiftInfoDetail,

};

function getShiftInfosByShopId(shopId) {
    return axios.get("auth/shift-info-by-shopId/" + shopId);
}

function getShiftInfoList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/shift-infos", { params });
}

function saveShiftInfo(shiftInfo) {
    if (!shiftInfo.id) {
        // new shiftInfo
        return axios.post("/auth/shift-info", shiftInfo);
    } else {
        // edit
        return axios.put("/auth/shift-info", shiftInfo);
    }
}

function getShiftInfoDetail(id) {
    return axios.get('/auth/shift-info/' + id);
}